import { render, staticRenderFns } from "./base-title-text.component.vue?vue&type=template&id=7f5ea3bc"
import script from "./base-title-text.component.ts?vue&type=script&lang=ts&external"
export * from "./base-title-text.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f5ea3bc')) {
      api.createRecord('7f5ea3bc', component.options)
    } else {
      api.reload('7f5ea3bc', component.options)
    }
    module.hot.accept("./base-title-text.component.vue?vue&type=template&id=7f5ea3bc", function () {
      api.rerender('7f5ea3bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/base-title-text/base-title-text.component.vue"
export default component.exports